export default {
  computed: {
    challengeName: {
      set(name) {
        this.updateFormData([
          { key: "challengeName", value: name },
          { key: "customRecognitionWallTitle", value: name }
        ]);
      },
      get() {
        return this.formData.challengeName.value;
      }
    },

    steps: {
      set(val) {
        this.updateFormData({ key: "steps", value: val });
      },
      get() {
        return this.formData.steps.value;
      }
    },

    startDate: {
      set(val) {
        this.updateFormData({ key: "startDate", value: val });
      },
      get() {
        return this.formData.startDate.value;
      }
    },

    endDate: {
      set(val) {
        this.updateFormData({ key: "endDate", value: val });
      },
      get() {
        return this.formData.endDate.value;
      }
    },

    duration: {
      set(val) {
        this.updateFormData({ key: "duration", value: val });
      },
      get() {
        return this.formData.duration.value;
      }
    },

    featured: {
      set(val) {
        this.updateFormData({ key: "featured", value: val });
      },
      get() {
        return this.formData.featured.value;
      }
    },

    between: {
      set(val) {
        this.updateFormData({ key: "between", value: val });
      },
      get() {
        return this.formData.between.value;
      }
    },

    publicAndOpen: {
      set(val) {
        // all admin created featured challenges are public (meaning, can be viewed in the 'all program challenges' list)
        // all admin created featured challenges are open (meaning, members can join freely, no invite needed)
        const publicVal = this.featured ? 1 : val;
        const openVal = this.featured ? 1 : val;
        this.updateFormData({ key: "open", value: openVal });
        this.updateFormData({ key: "public", value: publicVal });
      },
      get() {
        return this.formData.open.value;
      }
    },

    open: {
      set(val) {
        this.updateFormData({ key: "open", value: val });
      },
      get() {
        return this.formData.open.value;
      }
    },

    public: {
      set(val) {
        this.updateFormData({ key: "public", value: val });
      },
      get() {
        return this.formData.public.value;
      }
    },

    allowActivities: {
      set(val) {
        this.updateFormData({ key: "allowActivities", value: val });
      },
      get() {
        return this.formData.allowActivities.value;
      }
    },

    atStake: {
      set(text) {
        this.updateFormData({ key: "atStake", value: text });
      },
      get() {
        return this.formData.atStake.value;
      }
    },

    instant: {
      set(val) {
        this.updateFormData({ key: "instant", value: val });
      },
      get() {
        return this.formData.instant.value;
      }
    },

    addCreator: {
      set(val) {
        this.updateFormData({ key: "addCreator", value: val });
      },
      get() {
        return this.formData.addCreator.value;
      }
    },

    trackTextAndImagePoints: {
      set(val) {
        this.updateFormData({ key: "trackTextAndImagePoints", value: val });
      },
      get() {
        return this.formData.trackTextAndImagePoints.value;
      }
    },

    trackQuestionPoints: {
      set(val) {
        this.updateFormData({ key: "trackQuestionPoints", value: val });
      },
      get() {
        return this.formData.trackQuestionPoints.value;
      }
    },

    pointsGoal: {
      set(val) {
        this.updateFormData({ key: "pointsGoal", value: val });
      },
      get() {
        return this.formData.pointsGoal.value;
      }
    },

    incentivizeChallenge: {
      set(val) {
        this.updateFormData({ key: "incentivizeChallenge", value: val });
      },
      get() {
        return this.formData.incentivizeChallenge.value;
      }
    },

    incentiveType: {
      set(val) {
        this.updateFormData({ key: "incentiveType", value: val });
      },
      get() {
        return this.formData.incentiveType.value;
      }
    },

    incentiveAmount: {
      set(val) {
        this.updateFormData({ key: "incentiveAmount", value: val });
      },
      get() {
        return this.formData.incentiveAmount.value;
      }
    },

    allowAddingCompletionDate: {
      set(val) {
        this.updateFormData({ key: "allowAddingCompletionDate", value: val });
      },
      get() {
        return this.formData.allowAddingCompletionDate.value;
      }
    },

    allowFreeTextInput: {
      set(val) {
        this.updateFormData({ key: "allowFreeTextInput", value: val });
      },
      get() {
        return this.formData.allowFreeTextInput.value;
      }
    },

    trackingCalc: {
      set(val) {
        this.updateFormData({ key: "trackingCalc", value: val });
      },
      get() {
        return this.formData.trackingCalc.value;
      }
    },

    customRecognitionWallTitle: {
      set(val) {
        this.updateFormData([
          { key: "customRecognitionWallTitle", value: val }
        ]);
      },
      get() {
        return this._.get(
          this.formData,
          "customRecognitionWallTitle.value",
          "Wellness"
        );
      }
    },

    useCustomRecognitionWallTitle: {
      set(val) {
        const isEnabled = val === 1;

        this.disableCustomRecognitionWallTitle = !isEnabled;

        if (!isEnabled) {
          this.updateFormData([
            { key: "customRecognitionWallTitle", value: "Wellness" },
            { key: "useCustomRecognitionWallTitle", value: val }
          ]);
        } else {
          this.updateFormData([
            { key: "useCustomRecognitionWallTitle", value: val },
            { key: "customRecognitionWallTitle", value: this.challengeName }
          ]);
        }
      },
      get() {
        return this._.get(
          this.formData,
          "useCustomRecognitionWallTitle.value",
          0
        );
      }
    }
  }
};
